import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IGetSimilar, RestDataService} from '../../../services/rest-data.service';
import {marker as _} from '@biesbjerg/ngx-translate-extract-marker';

@Component({
    selector: 'app-inventory-number-input',
    templateUrl: './inventory-number-input.component.html',
    styleUrls: ['./inventory-number-input.component.scss']
})
export class InventoryNumberInputComponent implements OnInit {

    @Input() inline = false;
    @Input() onlyExisting = false;
    @Input() allowExisting = true;
    @Input() allowUnchanged = false;
    @Input() notAllowed: string[] = [];
    @Input() showExisting = true;
    @Input() invnr: string = '';
    @Output() invnrChange = new EventEmitter<string>();

    public allowed: string[] = [];
    public lookupFunction: IGetSimilar = this.dataService.getSimilarInvNr.bind(this.dataService);
    public invalidPatternRegExp = /[^0-9]/g;

    public valid: boolean = false;

    constructor(private dataService: RestDataService) {
        _('inventory_number.input');
        _('inventory_number.input-short');
        _('inventory_number.input-duplicate');
        _('inventory_number.input-short');
        _('inventory_number.input-not-existing');
        _('inventory_number.chooser');
    }

    ngOnInit(): void {
        if (this.allowUnchanged) this.allowed.push(this.invnr);
    }

    valueChange(value: string) {
        this.invnr = value;
        // noinspection RedundantIfStatementJS
        if (value && (value.length === 10)) this.valid = true;
        else this.valid = false;
        this.invnrChange.next(value);
    }

    valueChosen(value: string) {
        this.invnr = value;
        this.invnrChange.next(value);
    }
}
